export interface IDocumentTemplateBasicStructure {
    Id: string;
    blocks: any[];
}

export const FiDocumentTemplateBasicStructures: IDocumentTemplateBasicStructure[] = [
    {
        Id: 'D',
        blocks: new Array(2),
    },
    {
        Id: 'G',
        blocks: new Array(2),
    },
    {
        Id: 'H',
        blocks: new Array(2),
    },
    {
        Id: 'I',
        blocks: new Array(3),
    },
    {
        Id: 'C',
        blocks: new Array(3),
    },
    {
        Id: 'J',
        blocks: new Array(3),
    },
    {
        Id: 'K',
        blocks: new Array(3),
    },
    {
        Id: 'L',
        blocks: new Array(3),
    },
    {
        Id: 'M',
        blocks: new Array(3),
    },
    {
        Id: 'F',
        blocks: new Array(3),
    },
    {
        Id: 'A',
        blocks: new Array(4),
    },
    {
        Id: 'B',
        blocks: new Array(5),
    },
    {
        Id: 'E',
        blocks: new Array(6),
    },
    {
        Id: 'N',
        blocks: new Array(4),
    },
];
